{
  "AllNotifications": "Todas las notificaciones",
  "NoLinkNotification": "No hay vínculos disponibles para esta notificación",
  "ViewAllAnnouncementTab": "Anuncios",
  "ViewallNotificationTab": "Notificaciones",
  "preferences": "Editar preferencias"
}
